import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocketService } from '@/app/core/services/socket.service';

@Component({
  selector: 'app-live-toasts',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed bottom-4 right-4 flex flex-col gap-2 z-50" *ngIf="latestToast() as t">
      <div
        class="px-4 py-2 rounded shadow text-sm text-white animate-fade-in"
        [ngClass]="{
          'bg-green-600': t.type === 'success',
          'bg-red-600': t.type === 'error',
          'bg-yellow-600': t.type === 'warning',
          'bg-indigo-600': t.type === 'info',
        }"
      >
        {{ t.message }}
      </div>
    </div>
  `,
  styles: [
    '.animate-fade-in{animation:fade-in .25s ease-in}@keyframes fade-in{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:translateY(0)}}',
  ],
})
export class LiveToastsComponent {
  private socket = inject(SocketService);

  latestToast = computed(() => {
    const list = this.socket.toasts();
    return list.length ? list[list.length - 1] : null;
  });
}
